import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Icon: FunctionalComponent<{
  size?: 's' | 'm' | 'l'
}> = props => {
  return (
    <div class={classNames(styles.root, styles[props.size ?? 'm'])}>
      {props.children}
    </div>
  )
}
